import React, { useState } from "react"
import * as styles from "./outlinkClickable.module.scss"
import Clickable from "../clickable"
import Modal from "../modal"

const OutlinkClickable = React.memo(({ link, qr, className, children }) => {
  const [modalVisible, setModalVisible] = useState(null)
  return (
    <>
      <Modal
        isOpen={modalVisible !== null}
        shouldCloseOnOverlayClick
        onRequestClose={() => {
          setModalVisible(null)
        }}
      >
        <div className={styles.modalBox}>
          {modalVisible === "" ? (
            "尽情期待"
          ) : (
            <img src={modalVisible} alt="二维码扫码" />
          )}
        </div>
      </Modal>
      <Clickable
        className={className}
        {...(link
          ? { appNavTo: link }
          : {
              onClick: () => {
                setModalVisible(qr || "")
              },
            })}
      >
        {children}
      </Clickable>
    </>
  )
})

OutlinkClickable.displayName = "OutlinkClickable"
export default OutlinkClickable
